/* gallery-lightbox.js – minimal, caption-ready, swipe-enabled */
(() => {
  const ready = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else { fn(); }
  };

  ready(() => {
    const root = document.querySelector('[data-lightbox-root]');
    if (!root) return;

    const stage     = root.querySelector('.lb-stage');
    const captionEl = root.querySelector('.lb-caption');
    const counterEl = root.querySelector('.lb-counter');
    const btnPrev   = root.querySelector('.lb-prev');
    const btnNext   = root.querySelector('.lb-next');
    const btnClose  = root.querySelector('.lb-close');

    // 收集图片
    const sources = Array.from(document.querySelectorAll('[data-gallery-item]'));
    if (!sources.length) return;

    const items = sources.map((el, idx) => {
      el.dataset.index = String(idx);
      return {
        el,
        src: el.dataset.src || el.querySelector('img')?.currentSrc || el.querySelector('img')?.src || '',
        caption: el.dataset.caption || el.querySelector('img')?.alt || ''
      };
    });

    let current = 0;
    let opened  = false;

    function render() {
      // 清空并渲染图片
      stage.innerHTML = '';
      const img = new Image();
      img.decoding = 'async';
      img.loading  = 'eager';
      img.alt = items[current].caption || '';
      img.style.maxWidth  = '100vw';
      img.style.maxHeight = '100vh';
      img.style.width  = 'auto';
      img.style.height = 'auto';
      img.style.objectFit = 'contain';
      img.src = items[current].src;
      stage.appendChild(img);

      // 写入 caption & 计数
      if (captionEl) captionEl.textContent = items[current].caption || '';
      if (counterEl) counterEl.textContent = `${current + 1} / ${items.length}`;

      // 暴露给调试
      window.__lastLightboxItem = items[current];
    }

    function openAt(i) {
      current = (i + items.length) % items.length;
      root.hidden = false;
      document.documentElement.classList.add('lb-open');
      document.body.classList.add('lb-open');
      opened = true;
      render();
    }

    function close() {
      if (!opened) return;
      opened = false;
      root.hidden = true;
      document.documentElement.classList.remove('lb-open');
      document.body.classList.remove('lb-open');
    }

    function next() { openAt(current + 1); }
    function prev() { openAt(current - 1); }

    // 绑定缩略图点击
    sources.forEach((el, idx) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        openAt(idx);
      });
    });

    // 按钮点击
    btnNext?.addEventListener('click', (e) => { e.stopPropagation(); next(); });
    btnPrev?.addEventListener('click', (e) => { e.stopPropagation(); prev(); });
    btnClose?.addEventListener('click', (e) => { e.stopPropagation(); close(); });

    // 点击遮罩关闭（只点击到根容器才关闭，避免点到图片误关）
    root.addEventListener('click', (e) => {
      if (e.target === root) close();
    });

    // 键盘
    document.addEventListener('keydown', (e) => {
      if (root.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') next();
      if (e.key === 'ArrowLeft') prev();
    });

    // 移动端轻扫（灯箱内部专用，与网格是否启用滑动无关）
    (function enableSwipe(el) {
      let x0 = null, y0 = null, t0 = 0;
      const THRESHOLD = 40;  // 横向位移阈值
      const TIME_MAX  = 600; // 毫秒

      el.addEventListener('touchstart', (e) => {
        const t = e.changedTouches[0];
        x0 = t.clientX; y0 = t.clientY; t0 = Date.now();
      }, { passive: true });

      el.addEventListener('touchend', (e) => {
        if (x0 == null) return;
        const t = e.changedTouches[0];
        const dx = t.clientX - x0;
        const dy = t.clientY - y0;
        const dt = Date.now() - t0;
        x0 = y0 = null;

        // 横向为主且在时间内
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > THRESHOLD && dt < TIME_MAX) {
          if (dx < 0) next(); else prev();
        }
      }, { passive: true });
    })(stage);

    // 避免重复绑定（如果主题热替换）
    root.dataset.glbReady = '1';
  });
})();
